<template>
    <ui-modal :title="title" :close="close" :no-cancel="true">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <i class="far fa-exclamation-triangle text-red-600"></i>
            </div>
        </template>
        <p class="text-sm leading-5 text-gray-500" v-for="(paragraph, index) in paragraphs" :key="index">
            <span v-if="paragraph!==''" v-text="paragraph"></span>
            <span v-else>&nbsp;</span>
        </p>
        <template #footer-primary>
            <ui-button-new danger class="w-full" @click="close" v-text="button"></ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
export default {
    props: {
        handle: Function,
        close: Function,
        title: {
            type: String,
            default: 'Error.'
        },
        paragraphs: {
            type: Array,
            default: () => [
                'Error',
            ],
        },
        button: {
            type: String,
            default: 'OK'
        },
    },
    data() {
        return {}
    },
}
</script>
